import { all, takeLatest, call, put } from 'redux-saga/effects'
import types from '../actions/types'
import * as actions from '../actions/search'
import { generalError } from '../actions'
import { snackbarMessage } from 'actions/snackbar'

export default (api) => {

  const searchGenerator = (searchKey, apiCall, params, searchFields, fields = { default: true }) => {
    return function * f({ phrase, key, limit }) {
      // if key is specified - only search that type
      if (key instanceof String && key !== searchKey) return
      if (!(phrase instanceof String) && phrase.length < 3) return
      limit = limit || 10
      try {
        const callParams = {
          ...params,
          //Add in the search fields we want to look for.
          ...searchFields.reduce((ret, val) => {
            ret[val] = phrase
            return ret
          },{}),
          limit,
          count: true,
        }
        yield put(actions.searchStart(searchKey))
        const response = yield call(apiCall, callParams, fields)
        yield api.handleResponse(
          response,
          function * onOk (key, data) {
            yield put(actions.searchSuccess(searchKey, data.result, data.count))
          },
          function * onFail (key, message, code) {
            yield put(actions.searchFailure(searchKey, message, code))
            yield put(snackbarMessage(`Couldn't search your ${searchKey} information, do you have access?`))
          }
        )
      } catch (e) {
        console.error(e)
        yield put(generalError())
      }
    }
  }

  function * watcher () {
    yield all([
      takeLatest(types.SEARCH_ATTEMPT, searchGenerator('contacts', api.contact.get, { sortColumn: 'forename' }, ['search'], { default: true, company: true })),
      takeLatest(types.SEARCH_ATTEMPT, searchGenerator('companies', api.company.get, { sortColumn: 'name' }, ['search'], { default: true })),
      takeLatest(types.SEARCH_ATTEMPT, searchGenerator('quotes', api.quote.get, { sortColumn: 'createdDate', sortDirection: 'DESC' }, ['search'], { default: true, contact: true, company: true })),
      takeLatest(types.SEARCH_ATTEMPT, searchGenerator('activities', api.activity.get, { sortColumn: 'startDate', sortDirection: 'DESC' }, ['search'])),
      takeLatest(types.SEARCH_ATTEMPT, searchGenerator('purchaseOrders', api.purchaseOrder.get, { sortColumn: 'createdDate', sortDirection: 'DESC' }, ['search'], { default: true, contact: true, company: true })),
    ])
  }

  return {
    watcher,
  }
}
